"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.variantGetActionRequiredLines = void 0;
const getOrderLineCompletionStatus_1 = require("./getOrderLineCompletionStatus");
const variantGetActionRequiredLines = (variant) => {
    if (!variant)
        return null;
    if (!variant.order_lines)
        return null;
    return variant.order_lines.filter((line) => !(0, getOrderLineCompletionStatus_1.getOrderLineCompletionStatus)(line));
};
exports.variantGetActionRequiredLines = variantGetActionRequiredLines;
